import React, { useEffect } from "react";
import FillAssignment from "../../FillInForm/FillAssignment";
import { useAssignmentStore } from "pages/AppPages/PatientPages/AssignmentsForPatients/assignmentStore";
import { Assignment } from "types";
import "../../FillInForm/FillInForm.styles.scss";

interface PublicAssignmInfoProps {
  publicAssignmInfo: {
    therapistId: string;
    therapistName: string;
    therapistEmail: string;
    therapistIcon: string;
    practiceName: string;
    practiceLogo: string;
    groupName: string;
    assignment: Assignment;
  };
  visible: boolean;
}
const PublicAssignmentBody = ({
  publicAssignmInfo,
  visible,
}: PublicAssignmInfoProps) => {
  const { state, dispatch } = useAssignmentStore();

  useEffect(() => {
    dispatch({
      location: {
        assignmentSlug: publicAssignmInfo.assignment.slug,
        sectionSlug: "",
      },
    });
  }, [dispatch, publicAssignmInfo.assignment.slug]);

  return (
    <>
      {state?.activeAssignment?.slug && (
        <FillAssignment
          singlePatient={null}
          selectedPatient={null}
          group={null}
          assignment={publicAssignmInfo.assignment}
          hideFromPatient={visible ? false : true}
          requestPin={false}
          publicLink={true}
          publicAssignmInfo={publicAssignmInfo}
        />
      )}
    </>
  );
};

export default PublicAssignmentBody;
